import { ApplierOption } from '~/apps/smartsend/lib/helpers/ApplierOption';
import { SmartSendFilter } from '~/apps/smartsend/lib/helpers/SmartSendFilterApplier';

export const GetApplierOptionsFromFilter = (x: SmartSendFilter): ApplierOption[] =>
  x.FilterSelections.filter((y) => y.Name === 'Issues').flatMap((y) => y.Include) as ApplierOption[];

export const GetApplierOptionFromFilter = (x: SmartSendFilter): ApplierOption => GetApplierOptionsFromFilter(x)[0];
